import { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectOffersStatus } from 'shared/selectors/offers';
import { EOffersStatus } from 'shared/types/offers';
import { SkeletonListContainerMobile } from '../SkeletonListContainerMobile';
import { OffersContainerDesktop } from '../OffersContainerDesktop';
import { OffersLoadErrorContainer } from '../OffersLoadErrorContainer';
import { useDeviceType } from '../../context';
import { OffersContainerMobile } from '../OffersContainerMobile';
import { AdaptiveContainer } from 'shared/containers/AdaptiveContainer';
import { SkeletonListContainerDesktop } from '../SkeletonListContainerDesktop';

export const OffersContentContainer: FC = () => {
  const status = useSelector(selectOffersStatus);

  switch (status) {
    case EOffersStatus.Pending: {
      return (
        <AdaptiveContainer
          desktop={SkeletonListContainerDesktop}
          mobile={SkeletonListContainerMobile}
          useDeviceType={useDeviceType}
        />
      );
    }

    case EOffersStatus.Ready: {
      return (
        <AdaptiveContainer
          desktop={OffersContainerDesktop}
          mobile={OffersContainerMobile}
          useDeviceType={useDeviceType}
        />
      );
    }

    case EOffersStatus.Failed:
      return <OffersLoadErrorContainer />;

    default:
      return null;
  }
};
